import { render, staticRenderFns } from "./created-models-list.html?vue&type=template&id=36db2c14&scoped=true&external"
import script from "./created-models-list.js?vue&type=script&lang=js&external"
export * from "./created-models-list.js?vue&type=script&lang=js&external"
import style0 from "./created-models-list.scss?vue&type=style&index=0&id=36db2c14&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36db2c14",
  null
  
)

export default component.exports